export const buildDiscoveryParams = ({
  searchCenter,
  radius,
  type,
  styles = [],
  access = [],
  difficulty = [],
  dryWeather = false,
  openNow = false,
  minTrails = 0,
  maxDrive = 0,
  minRating = 0,
}) => {
  const params = { type };

  if (searchCenter) {
    params.lat = searchCenter.lat;
    params.lng = searchCenter.lng;
    params.radius = radius;
  }
  if (styles.length) params.styles = styles.join(",");
  if (access.length) params.access = access.join(",");
  if (difficulty.length) params.difficulty = difficulty.join(",");
  if (dryWeather) params.dry_weather = true;
  if (openNow) params.open_now = true;
  if (minTrails) params.min_trails = minTrails;
  if (maxDrive) params.max_drive = maxDrive;
  if (minRating) params.min_rating = minRating;

  return params;
};

export const centersDiffer = (a, b, epsilon = 0.00001) => {
  if (!a || !b) return Boolean(a || b);
  return Math.abs(a.lat - b.lat) > epsilon || Math.abs(a.lng - b.lng) > epsilon;
};

export const mapAreaSearchCenter = ({ lat, lng }) => ({
  lat,
  lng,
  name: "this map area",
});
